import { render, staticRenderFns } from "./TheAuthFormWrapperView.vue?vue&type=template&id=56772362&"
import script from "./TheAuthFormWrapperView.vue?vue&type=script&lang=js&"
export * from "./TheAuthFormWrapperView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports